import type { ReactNode } from 'react'
import { useZeroOnline } from '@rocicorp/zero/react'
import { useAuth } from '../auth/AuthContext.tsx'

function ConnStatus() {
  const online = useZeroOnline()
  return (
    <span className="status-line" title={online ? 'Live-syncing' : 'Offline'}>
      <span className={`dot ${online ? 'dot--on' : 'dot--off'}`} />
      {online ? 'Live' : 'Offline'}
    </span>
  )
}

export function Shell({
  title,
  children,
  wide = false,
  onBack,
  showSync = true,
}: {
  title: string
  children: ReactNode
  wide?: boolean
  onBack?: () => void
  showSync?: boolean
}) {
  const { session, logout } = useAuth()
  return (
    <div className={`app-layout ${wide ? 'app-layout--wide' : ''}`}>
      <header className="app-header">
        {onBack ? (
          <button className="back-link" onClick={onBack}>
            ‹ Back
          </button>
        ) : null}
        <h1>{title}</h1>
        <div className="spacer" />
        {showSync ? <ConnStatus /> : null}
        {session ? (
          <>
            <span className="who">
              {session.auth.name}
              {session.auth.role === 'admin' ? <span className="pill-tag pill-tag--admin"> admin</span> : null}
            </span>
            <button className="btn-ghost" onClick={() => void logout()}>
              Log out
            </button>
          </>
        ) : null}
      </header>
      <main className="app-main">{children}</main>
    </div>
  )
}
